import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { getItemContentStyles, getStandardNumberStyles, getSubtleNumberStyles } from '../../styles/listOrdered'
import { Flex } from '../layout/Flex'
import Stack from '../layout/Stack'
import Text from '../Text/Text'

export type ListOrderedTypes = 'standard' | 'subtle'

export type ListOrderedItem = {
  label: string
  body?: string
}
export interface ListOrderedProps {
  type?: ListOrderedTypes
  // TODO: remove React.ReactNode once migrated to ListOrderedItem[]
  items: (React.ReactNode | ListOrderedItem)[]
}

const StandardNumber = styled(Flex)`
  ${({ theme }) => getStandardNumberStyles(theme)}
`

const SubtleNumber = styled(Flex)`
  ${({ theme }) => getSubtleNumberStyles(theme)}
`

const ItemContent = styled.div<{ type: ListOrderedTypes }>`
  ${({ theme, type }) => getItemContentStyles(theme, type)}
`

const NumberText = styled.span`
  padding-bottom: 0.125rem;
`

const ListOrdered = ({ type = 'standard', items }: ListOrderedProps) => {
  const theme = useTheme()

  if (Array.isArray(items) && items.length > 9) {
    // eslint-disable-next-line no-console -- warning about possible design issue
    console.warn(
      'ListOrdered: The maximum number of items per the Arcade designs is 9, you may see rendering inconsistencies.'
    )
  }

  const NumberBulletType = type === 'standard' ? StandardNumber : SubtleNumber

  return (
    <Stack as="ol" space={theme.spacing.m}>
      {Array.isArray(items) &&
        items.map((item, index) => {
          return (
            <Flex as="li" key={index} gap={theme.spacing.m} alignItems="baseline">
              {/* Note: no affordance for i18n because the designs don't take it into account */}
              <NumberBulletType alignItems="center" justifyContent="center">
                <NumberText>{index + 1}</NumberText>
              </NumberBulletType>
              {/* TODO: this is here for backwards compatibility, will remove this brittle check once migrated to ListOrderedItem[] */}
              {typeof item === 'object' && item !== null && 'label' in item ? (
                // Item is a ListOrderedItem
                <Stack space={theme.spacing.empty}>
                  <Text typography={item.body ? 'labelMedium' : 'body'} color="textStandard">
                    {item.label}
                  </Text>
                  {item.body && (
                    <Text typography="body" color="textSubtle">
                      {item.body}
                    </Text>
                  )}
                </Stack>
              ) : (
                // TODO: remove ItemContent once migrated to ListOrderedItem[]
                // Item is a ReactNode (string, JSX, etc.)
                <ItemContent type={type}>{item}</ItemContent>
              )}
            </Flex>
          )
        })}
    </Stack>
  )
}

export default ListOrdered
